export default __webpack_public_path__ + "static/media/btn_step_3_hover.0727bbe1.svg";